import { render, staticRenderFns } from "./ContactPersons.vue?vue&type=template&id=7d28a834&"
import script from "./ContactPersons.vue?vue&type=script&lang=js&"
export * from "./ContactPersons.vue?vue&type=script&lang=js&"
import style0 from "./ContactPersons.vue?vue&type=style&index=0&id=7d28a834&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports